module.exports = __webpack_public_path__ + "static/media/infant.56c71e5f.jpg";